export const ITEMTYPE_RICHTEXT = 'RICHTEXT';
export const ITEMTYPE_IMAGE = 'IMAGE';
export const ITEMTYPE_VIDEO = 'VIDEO';
